import {
  ecom_gfx,
  ai_gfx,
  graifka_gfx,
  base_gfx,
  js_gfx,
  marketplace_gfx,
  about_photo,
  about_photo_jpg,
  hero_photo
} from "../img";

// Dane do sekcji NAV
export const navLinks = [
  { id: "about", label: "O mnie" },
  { id: "skills", label: "Umiejętności" },
  { id: "contact", label: "Kontakt" }
];

// Dane do sekcji HERO
export const hero = {
  logoAlt: "",
  logoText: "Mateusz Stelmaszczyk",
  photoAlt: "",
  heading: "Cześć, nazywam się Mateusz",
  subheading:
    "Jestem specjalistą ds. E-Commerce, Marketplace, integracji Base oraz Automatyzacji AI",
  photoPlaceholder: hero_photo
};

// Dane do sekcji ABOUT
export const about = {
  photoAlt: "",
  photoPlaceholder: about_photo_jpg,
  heading: "W skrócie na mój temat",
  // description: `Specjalizuję się w e-commerce i sprzedaży na marketplace'ach takich jak Allegro, Erli, Empik czy Amazon. Tworzę skuteczne opisy produktów, optymalizuję oferty i zarządzam integracjami z BaseLinkerem. Automatyzuję procesy sprzedażowe z wykorzystaniem AI i n8n – od wystawiania ofert po obsługę klienta. Łączę doświadczenie techniczne z praktyczną znajomością handlu internetowego, co pozwala mi budować rozwiązania zwiększające sprzedaż i oszczędzające czas.`,
  description: `Na co dzień zajmuję się e-commerce i sprzedażą na platformach takich jak Allegro, Erli, Empik czy Amazon. Specjalizuję się w tworzeniu opisów, optymalizacji ofert, integracjach z BaseLinkerem oraz automatyzacjach opartych na AI i n8n. Łączę techniczne podejście z praktycznym doświadczeniem, a przy tym naprawdę lubię to, co robię. Dzięki temu tworzę rozwiązania, które usprawniają sprzedaż, oszczędzają czas i realnie zwiększają wyniki. Więcej możesz dowiedzieć się, rozmawiając z moim asystentem AI – jest dostępny na czacie na stronie.`,
  cvLink: "#",
  cvLabel: "Pobierz CV"
};

// Dane do sekcji SKILLS
export const skillsSection = {
  heading: "Moje Umiejętności",
  subheading: "Poznaj moje umiejętności i zobacz, co mogę dla Ciebie zrobić",
  skills: [
    {
      id: "ecommerce",
      icon: ecom_gfx,
      title: "E-Commerce",
      short:
        "Zajmuję się kompleksową obsługą e-commerce – od tworzenia ofert po automatyzacje procesów sprzedaży i zarządzanie sklepami na różnych platformach.",
      details:
        "E-commerce to moja codzienność – projektuję procesy sprzedaży w sklepach internetowych, optymalizuję opisy i struktury kategorii, wdrażam systemy usprawniające obsługę zamówień i automatyzuję powtarzalne działania. Dbam o to, by każdy etap – od wejścia klienta na stronę, aż po finalizację transakcji – działał sprawnie, efektywnie i wspierał wzrost sprzedaży."
    },
    {
      id: "marketplace",
      icon: marketplace_gfx,
      title: "Marketplace",
      short:
        "Zajmuję się profesjonalną obsługą sprzedaży na marketplace’ach – od konfiguracji konta po optymalizację ofert i zarządzanie procesami sprzedaży.",
      details:
        "Obsługuję sprzedaż na platformach takich jak Allegro, Erli, Empik czy Amazon. Pomagam w konfiguracji konta, tworzeniu i optymalizacji ofert, zarządzaniu stanami magazynowymi i cennikami. Dbam o spójność i jakość treści, poprawność integracji oraz skuteczne pozycjonowanie ofert. Dzięki znajomości algorytmów i narzędzi platform marketplace zwiększam widoczność, sprzedaż i satysfakcję klientów."
    },
    {
      id: "base",
      icon: base_gfx,
      title: "Integracje Base.com (Baselinker)",
      short:
        "Integruję systemy sprzedażowe z BaseLinkerem – łączę sklepy, marketplace’y, hurtownie i systemy księgowe w jeden sprawnie działający ekosystem.",
      details:
        "Specjalizuję się w integracjach z BaseLinkerem – podpinam sklepy internetowe, konta marketplace, hurtownie, systemy ERP i fakturowania. Konfiguruję synchronizację produktów, zamówień, płatności i wysyłek. Tworzę niestandardowe połączenia i automatyzacje, które ułatwiają codzienną pracę, eliminują błędy i oszczędzają czas. Dzięki temu wszystkie elementy sprzedaży działają spójnie i bez zbędnego chaosu."
    },
    {
      id: "grafika",
      icon: graifka_gfx,
      title: "Grafika",
      short:
        "Tworzę grafiki produktowe, banery i miniatury oraz zajmuję się obróbką zdjęć – wszystko po to, by wizualna strona oferty przyciągała uwagę i zwiększała sprzedaż.",
      details:
        "Zajmuję się tworzeniem estetycznych grafik do sklepów i marketplace’ów – od zdjęć produktowych po banery i miniatury. Obrabiam zdjęcia: kadrowanie, usuwanie tła, poprawa kolorystyki, dopasowanie do wytycznych platform. Dbam o spójność wizualną i przyciągający wygląd, który wyróżnia ofertę na tle konkurencji. Dobrze przygotowana oprawa graficzna to kluczowy element skutecznej sprzedaży online."
    },
    {
      id: "automatyzacje",
      icon: ai_gfx,
      title: "Automatyzacje AI",
      short:
        "Automatyzuję procesy biznesowe z wykorzystaniem AI – od tworzenia treści po integracje i zadania operacyjne, które działają bez potrzeby ciągłej kontroli.",
      details:
        "Projektuję automatyzacje z użyciem AI, które usprawniają codzienną pracę – generowanie opisów, odpowiadanie na wiadomości, zarządzanie ofertami czy przetwarzanie danych. Korzystam z narzędzi takich jak n8n, OpenAI czy webhooki, łącząc je z systemami e-commerce i CRM. Tworzę procesy, które działają samodzielnie, eliminując powtarzalne zadania i oszczędzając czas. Automatyzacja to sposób na większą efektywność i mniejszy chaos w firmie."
    },
    {
      id: "js",
      icon: js_gfx,
      title: "Javascript",
      short:
        "Tworzę dynamiczne rozwiązania webowe w JavaScript – od prostych skryptów po rozbudowane funkcje wspierające sprzedaż i automatyzację procesów.",
      details:
        "JavaScript to mój codzienny język pracy – piszę funkcje do obsługi formularzy, walidacji danych, dynamicznych interfejsów i automatyzacji procesów e-commerce. Tworzę rozwiązania dopasowane do potrzeb klienta – od prostych snippetów po integracje z API i logikę biznesową. Dzięki znajomości JS potrafię szybko wdrożyć zmiany, które realnie usprawniają działanie stron, paneli czy narzędzi online."
    }
  ]
};

// Dane do sekcji CONTACT
export const contact = {
  heading: "Kontakt",
  subheading: "Masz pytania? Napisz do mnie!",
  nameLabel: "Imię i nazwisko",
  emailLabel: "Adres e-mail",
  phoneLabel: "Numer telefonu",
  messageLabel: "Wiadomość",
  submitLabel: "Wyślij wiadomość",
  successMessage: "Dziękuję za kontakt! Odpowiem najszybciej jak to możliwe.",
  errorMessage: "Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.",
  botProtection: "Potwierdź, że nie jesteś robotem",
  webhook: "https://matstel.pl/webhook/181f8c9a-7806-40aa-adf2-a40f6bffe395"
};

// Dane do sekcji CHAT
export const chat = {
  welcome:
    "Cześć! Jestem asystentem AI Mateusza. Masz dodatkowe pytania o umiejętności, przebieg kariery zawodowowej lub potrzebujesz bezpośredniego kontaktu? Zapraszam do rozmowy",
  askName: "Imię *",
  askEmail: "Aby rozpocząć rozmowę, podaj swój adres e-mail:",
  askPhone: "Możesz też zostawić numer telefonu (opcjonalnie):",
  startChat: "Rozpocznij rozmowę",
  placeholder: "Napisz wiadomość...",
  sendLabel: "Wyślij",
  webhook: "https://matstel.pl/webhook/48e3c80b-aa40-4cdb-ac72-3b3dda97edc0",
  autoOpenDelay: 5000, // ms
  nameRequired: "Podanie imienia jest wymagane.",
  emailRequired: "Podanie adresu e-mail jest wymagane.",
  phoneOptional: "Numer telefonu jest opcjonalny.",
  thankYou: "Dziękuję za wiadomość! Skontaktuję się z Tobą wkrótce.",
  // Nowe opcje chatu
  options: {
    career: "Zadaj pytanie o przebieg kariery zawodowej",
    skills: "Zadaj pytanie o umiejętności",
    contact: "Skontaktuj się z Mateuszem"
  },
  // Odpowiedzi na opcje
  responses: {
    career:
      "Mam wieloletnie doświadczenie w e-commerce i sprzedaży online. Zacząłem od pracy w sklepach internetowych, przez lata rozwijając umiejętności w zarządzaniu marketplace'ami, integracjach systemowych i automatyzacjach. Specjalizuję się w BaseLinkerze, AI i optymalizacji procesów sprzedażowych. Każdy projekt to dla mnie okazja do nauki i rozwoju. Masz dodatkowe pytania? Zapraszam do rozmowy",
    skills:
      "Moje główne umiejętności to: zarządzanie e-commerce, obsługa marketplace'ów (Allegro, Erli, Empik), integracje BaseLinker, automatyzacje AI, grafika produktowa i JavaScript. Łączę wiedzę techniczną z praktycznym doświadczeniem biznesowym. Masz dodatkowe pytania? Zapraszam do rozmowy",
    contact: "Zapraszam do rozmowy"
  }
};

// Polityka prywatności
export const privacyPolicy = {
  short: {
    title: "Polityka Prywatności - Skrót",
    content: `Ta strona używa plików cookie i podobnych technologii, aby zapewnić najlepsze doświadczenia użytkownika. 
    
    Gromadzimy tylko niezbędne dane: adres e-mail (jeśli podasz), informacje o sesji i podstawowe statystyki odwiedzin.
    
    Twoje dane są bezpieczne - nie sprzedajemy ich, nie udostępniamy osobom trzecim bez Twojej zgody i używamy ich tylko do świadczenia usług.
    
    Możesz w każdej chwili wycofać zgodę, usunąć dane lub zaktualizować swoje preferencje.`
  },
  full: {
    title: "Pełna Polityka Prywatności",
    content: `
    <h2>1. Administrator danych</h2>
    <p>Administratorem Twoich danych osobowych jest Mateusz Stelmaszczyk].</p>
    
    <h2>2. Cel przetwarzania danych</h2>
    <p>Twoje dane osobowe przetwarzamy w następujących celach:</p>
    <ul>
      <li>Świadczenie usług i obsługa klienta</li>
      <li>Komunikacja w sprawie ofert i projektów</li>
      <li>Analiza statystyczna i poprawa jakości usług</li>
      <li>Marketing bezpośredni (za zgodą)</li>
    </ul>
    
    <h2>3. Podstawa prawna</h2>
    <p>Dane przetwarzamy na podstawie:</p>
    <ul>
      <li>Realizacji umowy lub podjęcia działań przed zawarciem umowy</li>
      <li>Uzasadnionego interesu administratora</li>
      <li>Zgody użytkownika (w przypadku marketingu)</li>
    </ul>
    
    <h2>4. Rodzaje gromadzonych danych</h2>
    <p>Gromadzimy następujące kategorie danych:</p>
    <ul>
      <li>Dane identyfikacyjne (imię, nazwisko, e-mail)</li>
      <li>Dane kontaktowe (telefon)</li>
      <li>Dane techniczne (IP, cookies, logi serwera)</li>
      <li>Dane o aktywności (historia odwiedzin, preferencje)</li>
    </ul>
    
    <h2>5. Okres przechowywania</h2>
    <p>Dane przechowujemy przez okres:</p>
    <ul>
      <li>Realizacji umowy + 6 lat (wymogi podatkowe)</li>
      <li>Do wycofania zgody (marketing)</li>
      <li>Do momentu żądania usunięcia</li>
    </ul>
    
    <h2>6. Twoje prawa</h2>
    <p>Masz prawo do:</p>
    <ul>
      <li>Dostępu do swoich danych</li>
      <li>Poprawiania nieprawidłowych danych</li>
      <li>Usunięcia danych</li>
      <li>Ograniczenia przetwarzania</li>
      <li>Przenoszenia danych</li>
      <li>Wniesienia sprzeciwu</li>
      <li>Wycofania zgody</li>
    </ul>
    
    <h2>7. Bezpieczeństwo danych</h2>
    <p>Stosujemy odpowiednie środki techniczne i organizacyjne, aby chronić Twoje dane przed nieuprawnionym dostępem, utratą lub zniszczeniem.</p>
    
    <h2>8. Udostępnianie danych</h2>
    <p>Twoje dane mogą być udostępniane:</p>
    <ul>
      <li>Dostawcom usług IT i hostingowych</li>
      <li>Organom administracji publicznej (na żądanie)</li>
      <li>Innym podmiotom (za Twoją zgodą)</li>
    </ul>
    
    <h2>9. Pliki cookie</h2>
    <p>Używamy plików cookie do:</p>
    <ul>
      <li>Zapewnienia funkcjonalności strony</li>
      <li>Analizy ruchu i statystyk</li>
      <li>Personalizacji treści</li>
    </ul>
    
    <h2>10. Kontakt</h2>
    <p>W sprawach związanych z ochroną danych osobowych możesz kontaktować się z nami przez formularz na stronie lub bezpośrednio.</p>
    
    <h2>11. Zmiany polityki</h2>
    <p>Zastrzegamy sobie prawo do zmiany tej polityki. O istotnych zmianach będziemy informować na stronie.</p>
    
    <p><strong>Ostatnia aktualizacja:</strong> ${new Date().toLocaleDateString(
      "pl-PL"
    )}</p>
    `
  }
};

// Dane do sekcji FOOTER
export const footer = {
  copyright: `© ${new Date().getFullYear()} portfolio.matstel.pl. Wszelkie prawa zastrzeżone.`
};

// Dane do strony 404
export const notFound = {
  heading: "404",
  message: "Nie znaleziono strony, której szukasz.",
  backToHome: "Wróć na stronę główną"
};
